export const capitalizeFirstLetter = (text: string): string => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase();
};

export const twoDigitString = (number: number) => {
    return `${number}`.slice(-2);
};

export const urlRegex =
    /^(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
export const urlRegexOrEmpty =
    /^$|^(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

export const getDurationString = (minutes: number) => {
    const minute = twoDigitString(minutes % 60);
    if (minutes === 0) {
        return `12am`;
    }
    if (minutes >= 720 && minutes < 780) {
        return `12${minute === '0' ? '' : `:${minute}`}pm`;
    }
    const hour = twoDigitString(minutes / 60 === 12 ? 12 : Math.floor((minutes / 60) % 12));
    let ampm = '';
    if (minutes / 60 === 12 || Math.floor(minutes / 60) < 12) {
        ampm = 'am';
    } else {
        ampm = 'pm';
    }
    return `${hour}${minute === '0' ? '' : `:${minute}`}${ampm}`;
};

export const generateUrlFromUserName = (url: string, social: string) => {
    if (url.match(urlRegex)) return url;

    if (social === 'INSTAGRAM') {
        return `https://www.instagram.com/${url}`;
    }
    if (social === 'TWITTER') {
        return `https://twitter.com/${url}`;
    }
    return url;
};
